export interface AnimeItem {
  id: number;
  title: string;
  cover: string;
  category: string;
  episodes: string;
  score: number;
  description: string;
  updateInfo: string;
  year: number;
  studio: string;
  tags: string[];
}

export const allAnime: AnimeItem[] = [
  {
    id: 1,
    title: "鬼灭之刃 无限城篇",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20demon%20slayer%20poster%20with%20samurai%20swordsman%20in%20dark%20outfit%20holding%20katana%20against%20flame%20background%2C%20dramatic%20lighting%2C%20studio%20ufotable%20animation%20style%2C%20clean%20dark%20background%2C%20cinematic%20composition%2C%20high%20quality%20illustration&width=600&height=850&seq=anime-cover-01&orientation=portrait",
    category: "热血",
    episodes: "全26话",
    score: 9.6,
    description: "在无限城决战中，炭治郎与鬼杀队的伙伴们面对无惨的最终形态，展开了一场生死存亡的终极对决。本作为鬼灭之刃系列的完结篇，由ufotable倾力打造。",
    updateInfo: "已完结",
    year: 2025,
    studio: "ufotable",
    tags: ["热血", "战斗", "奇幻", "神作"]
  },
  {
    id: 2,
    title: "咒术回战 第二季",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20jujutsu%20sorcerer%20poster%20with%20white%20haired%20character%20wearing%20blindfold%20casting%20purple%20magic%20spell%2C%20dark%20urban%20background%2C%20mappa%20animation%20style%2C%20dynamic%20pose%2C%20supernatural%20energy%20effects%2C%20high%20contrast%2C%20cool%20tone%20lighting&width=600&height=850&seq=anime-cover-02&orientation=portrait",
    category: "热血",
    episodes: "全23话",
    score: 9.4,
    description: "涉谷事变篇震撼来袭！五条悟被封印，咒术界陷入前所未有的危机。虎杖悠仁与伙伴们面对特级咒灵的围攻，展开惊心动魄的战斗。",
    updateInfo: "已完结",
    year: 2023,
    studio: "MAPPA",
    tags: ["热血", "战斗", "超能力", "校园"]
  },
  {
    id: 3,
    title: "我推的孩子",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20idol%20poster%20with%20beautiful%20girl%20with%20star%20eyes%20in%20stage%20costume%20posing%20on%20stage%2C%20sparkling%20spotlight%20background%2C%20entertainment%20industry%20theme%2C%20emotional%20expression%2C%20soft%20dreamy%20lighting%2C%20professional%20illustration&width=600&height=850&seq=anime-cover-03&orientation=portrait",
    category: "恋爱",
    episodes: "全24话",
    score: 9.2,
    description: "从偶像粉丝转生为偶像孩子的奇幻故事。星野爱久爱海与星野瑠美衣在演艺圈中追逐梦想，揭示娱乐圈的光与影。",
    updateInfo: "已完结",
    year: 2023,
    studio: "动画工房",
    tags: ["恋爱", "偶像", "转生", "演艺圈"]
  },
  {
    id: 4,
    title: "葬送的芙莉莲",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20fantasy%20poster%20with%20elf%20girl%20with%20silver%20hair%20in%20white%20dress%20walking%20through%20flower%20field%2C%20adventure%20theme%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20sunset%20lighting%2C%20beautiful%20landscape%20background%2C%20emotional%20storytelling%20art&width=600&height=850&seq=anime-cover-04&orientation=portrait",
    category: "奇幻",
    episodes: "全28话",
    score: 9.7,
    description: "勇者小队打败魔王后，精灵魔法使芙莉莲踏上了理解人类情感的旅程。一部关于时间、记忆与羁绊的温情奇幻史诗。",
    updateInfo: "已完结",
    year: 2024,
    studio: "MADHOUSE",
    tags: ["奇幻", "冒险", "治愈", "神作", "催泪"]
  },
  {
    id: 5,
    title: "间谍过家家 第二季",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20spy%20family%20poster%20with%20suited%20man%20and%20woman%20and%20little%20pink%20haired%20girl%20posing%20as%20family%2C%20action%20comedy%20theme%2C%20clean%20bright%20background%2C%20heartwarming%20mood%2C%20wit%20studio%20style%2C%20professional%20anime%20illustration&width=600&height=850&seq=anime-cover-05&orientation=portrait",
    category: "搞笑",
    episodes: "全25话",
    score: 9.1,
    description: "间谍父亲、杀手母亲、超能力女儿——这个伪装家庭的日常充满了惊险与温馨。第二季更多爆笑情节与感人瞬间等你发现。",
    updateInfo: "已完结",
    year: 2023,
    studio: "WIT STUDIO",
    tags: ["搞笑", "家庭", "间谍", "温馨"]
  },
  {
    id: 6,
    title: "进击的巨人 最终季 完结篇",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20attack%20on%20titan%20poster%20with%20soldier%20character%20facing%20giant%20titan%20in%20apocalyptic%20setting%2C%20dark%20dramatic%20sky%2C%20epic%20war%20atmosphere%2C%20mappa%20animation%20quality%2C%20intense%20mood%2C%20high%20detail%20cinematic%20composition&width=600&height=850&seq=anime-cover-06&orientation=portrait",
    category: "热血",
    episodes: "全12话",
    score: 9.5,
    description: "艾伦发动地鸣，帕拉迪岛的命运悬于一线。曾经的战友成为对立面，在灭世与救赎之间，他们将做出最终的选择。",
    updateInfo: "已完结",
    year: 2023,
    studio: "MAPPA",
    tags: ["热血", "战斗", "末世", "史诗", "神作"]
  },
  {
    id: 7,
    title: "更衣人偶坠入爱河",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20romance%20poster%20with%20cosplay%20girl%20in%20elaborate%20costume%20smiling%20at%20shy%20boy%2C%20school%20setting%2C%20sweet%20romantic%20atmosphere%2C%20warm%20cherry%20blossom%20background%2C%20soft%20pastel%20colors%2C%20heartwarming%20mood&width=600&height=850&seq=anime-cover-07&orientation=portrait",
    category: "恋爱",
    episodes: "全12话",
    score: 8.9,
    description: "人偶匠人与Cosplayer少女的甜蜜恋爱物语。两个看似不搭边的灵魂因共同的热情而相遇，展开了一段温馨有趣的日常。",
    updateInfo: "已完结",
    year: 2022,
    studio: "CloverWorks",
    tags: ["恋爱", "校园", "Cosplay", "甜"]
  },
  {
    id: 8,
    title: "迷宫饭",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20cooking%20fantasy%20poster%20with%20adventurers%20cooking%20monsters%20in%20dungeon%20setting%2C%20delicious%20food%20detail%2C%20trigger%20animation%20style%2C%20warm%20campfire%20lighting%2C%20cozy%20dungeon%20atmosphere%2C%20fun%20adventure%20theme&width=600&height=850&seq=anime-cover-08&orientation=portrait",
    category: "搞笑",
    episodes: "全24话",
    score: 9.0,
    description: "在迷宫中烹饪魔物？莱欧斯小队为了拯救被炎龙吃掉的妹妹，一边冒险一边享用迷宫中的「美食」，开启前所未有的美食冒险！",
    updateInfo: "已完结",
    year: 2024,
    studio: "TRIGGER",
    tags: ["搞笑", "美食", "奇幻", "冒险"]
  },
  {
    id: 9,
    title: "药屋少女的呢喃",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20historical%20palace%20poster%20with%20apothecary%20girl%20in%20ancient%20Chinese%20style%20dress%20holding%20medicine%20bottle%2C%20elegant%20palace%20background%2C%20mystery%20theme%2C%20sophisticated%20art%20style%2C%20warm%20lantern%20lighting&width=600&height=850&seq=anime-cover-09&orientation=portrait",
    category: "奇幻",
    episodes: "全24话",
    score: 9.3,
    description: "被卖入后宫的猫猫凭借药学知识在后宫解决各种神秘事件。一桩桩离奇案件背后，隐藏着宫廷深处的秘密。",
    updateInfo: "已完结",
    year: 2024,
    studio: "TOHO animation",
    tags: ["奇幻", "宫廷", "推理", "医疗"]
  },
  {
    id: 10,
    title: "夏日重现",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20summer%20island%20suspense%20poster%20with%20boy%20and%20girl%20on%20beach%20with%20mysterious%20shadow%20looming%2C%20time%20loop%20concept%2C%20sunset%20coastal%20village%20background%2C%20thriller%20atmosphere%2C%20warm%20but%20creepy%20mood&width=600&height=850&seq=anime-cover-10&orientation=portrait",
    category: "奇幻",
    episodes: "全25话",
    score: 9.1,
    description: "回到故乡日都岛的少年慎平，陷入了时间循环的谜团之中。为了拯救青梅竹马，他必须揭开岛上的黑暗秘密。",
    updateInfo: "已完结",
    year: 2022,
    studio: "OLM",
    tags: ["奇幻", "悬疑", "时间循环", "推理"]
  },
  {
    id: 11,
    title: "孤独摇滚！",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20music%20band%20poster%20with%20pink%20haired%20shy%20girl%20playing%20guitar%20on%20stage%2C%20rock%20band%20theme%2C%20dynamic%20concert%20lighting%2C%20cute%20but%20cool%20atmosphere%2C%20cloverworks%20style%2C%20energetic%20mood&width=600&height=850&seq=anime-cover-11&orientation=portrait",
    category: "搞笑",
    episodes: "全12话",
    score: 9.2,
    description: "极度社恐的少女后藤独，梦想成为摇滚巨星。加入纽带乐队后，她的青春生活彻底改变——在音乐中找回自信与朋友。",
    updateInfo: "已完结",
    year: 2022,
    studio: "CloverWorks",
    tags: ["搞笑", "音乐", "青春", "治愈"]
  },
  {
    id: 12,
    title: "我心里危险的东西",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20school%20romance%20poster%20with%20tall%20girl%20and%20shorter%20boy%20in%20school%20uniform%20standing%20in%20library%2C%20shy%20romantic%20atmosphere%2C%20soft%20sunlight%20through%20window%2C%20sweet%20youth%20theme%2C%20delicate%20art%20style&width=600&height=850&seq=anime-cover-12&orientation=portrait",
    category: "恋爱",
    episodes: "全25话",
    score: 8.8,
    description: "中二病少年与班上人气美少女之间微妙的距离感。两个看似格格不入的人，在日常相处中渐渐靠近彼此的心。",
    updateInfo: "已完结",
    year: 2023,
    studio: "新锐动画",
    tags: ["恋爱", "校园", "青春", "治愈"]
  },
  {
    id: 13,
    title: "龙珠超 超级英雄",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20dragon%20ball%20poster%20with%20muscular%20warrior%20in%20orange%20gi%20charging%20energy%20attack%2C%20explosive%20dynamic%20background%2C%20action%20packed%2C%20shonen%20style%2C%20vibrant%20colors%2C%20classic%20toei%20animation%20quality&width=600&height=850&seq=anime-cover-13&orientation=portrait",
    category: "热血",
    episodes: "全131话",
    score: 9.0,
    description: "悟空与贝吉塔面对全新的威胁——人造人伽马。在红缎带军团的阴谋下，超级英雄们将再次挺身而出保护地球。",
    updateInfo: "连载中",
    year: 2022,
    studio: "东映动画",
    tags: ["热血", "战斗", "经典", "长篇"]
  },
  {
    id: 14,
    title: "关于邻家的天使大人不知不觉把我惯成了废人这档事",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20romance%20poster%20with%20beautiful%20angelic%20girl%20and%20ordinary%20boy%20sitting%20together%20on%20apartment%20balcony%2C%20everyday%20slice%20of%20life%2C%20warm%20afternoon%20sunlight%2C%20sweet%20cozy%20atmosphere%2C%20soft%20art%20style&width=600&height=850&seq=anime-cover-14&orientation=portrait",
    category: "恋爱",
    episodes: "全12话",
    score: 8.7,
    description: "住在隔壁的天使般的美少女椎名真昼，不知从何时起开始照顾起废柴邻居藤宫周的生活。一段温馨甜蜜的邻居恋爱故事。",
    updateInfo: "已完结",
    year: 2023,
    studio: "project No.9",
    tags: ["恋爱", "日常", "甜", "校园"]
  },
  {
    id: 15,
    title: "电锯人",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20chainsaw%20man%20poster%20with%20character%20with%20chainsaw%20head%20in%20urban%20battle%20scene%2C%20blood%20splatter%20effects%2C%20dark%20gritty%20atmosphere%2C%20mappa%20cinematic%20quality%2C%20raw%20visceral%20energy%2C%20punk%20aesthetic&width=600&height=850&seq=anime-cover-15&orientation=portrait",
    category: "热血",
    episodes: "全12话",
    score: 9.3,
    description: "为了偿还亡父的债务，少年淀治与恶魔啵奇塔签订契约成为电锯人，加入公安对魔特别行动组，与恶魔展开血腥战斗。",
    updateInfo: "已完结",
    year: 2022,
    studio: "MAPPA",
    tags: ["热血", "战斗", "黑暗", "邪道"]
  },
  {
    id: 16,
    title: "辉夜大小姐想让我告白 第三季",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20romantic%20comedy%20poster%20with%20student%20council%20president%20and%20vice%20president%20facing%20each%20other%20blushing%2C%20elegant%20school%20academy%20background%2C%20mind%20game%20theme%2C%20a1%20pictures%20quality%2C%20fun%20competitive%20mood&width=600&height=850&seq=anime-cover-16&orientation=portrait",
    category: "搞笑",
    episodes: "全13话",
    score: 9.3,
    description: "「先告白的人就输了！」——学生会会长与副会长之间天才般的恋爱头脑战迎来最高潮！奉心祭上，两人的感情终于迎来转折点。",
    updateInfo: "已完结",
    year: 2022,
    studio: "A-1 Pictures",
    tags: ["搞笑", "恋爱", "校园", "头脑战"]
  }
];

export const featuredAnimeIds = [1, 4, 9, 6, 2, 11];

export function getAnimeByCategory(category: string): AnimeItem[] {
  return allAnime.filter((a) => a.category === category);
}

export function getAnimeById(id: number): AnimeItem | undefined {
  return allAnime.find((a) => a.id === id);
}

export function getRelatedAnime(id: number, limit: number = 4): AnimeItem[] {
  const current = getAnimeById(id);
  if (!current) return [];
  return allAnime
    .filter((a) => a.id !== id && a.tags.some((t) => current.tags.includes(t)))
    .slice(0, limit);
}